import { Ticket } from 'utils/api/models/troubleTicketing/ticket';

const statuses: [
	types.troubleTicketing.status,
	types.troubleTicketing.typeOfTicket,
	types.troubleTicketing.finalStatus
][] = [
	['Accepted', 'INTERACTION', 'Accepted'],
	['Accepted', 'INCIDENT', 'Accepted'],
	['Adjustment in Progress', 'INCIDENT', 'Under process'],
	['Assign', 'INTERACTION', 'Under process'],
	['Assign', 'INCIDENT', 'Under process'],
	['Assigned to 4th Line', 'INCIDENT', 'Under process'],
	['Callback', 'INTERACTION', 'Under process'],
	['Canceled', 'INTERACTION', 'Closed'],
	['Cancelled', 'INCIDENT', 'Closed'],
	['Categorize', 'INTERACTION', 'Under process'],
	['Categorize', 'INCIDENT', 'Under process'],
	['Closed', 'INCIDENT', 'Completed'],
	['Closed', 'INTERACTION', 'Closed'],
	['Dispatched', 'INTERACTION', 'Under process'],
	['In Progress', 'INTERACTION', 'Under process'],
	['Open', 'INTERACTION', 'Accepted'],
	['Open', 'INCIDENT', 'Accepted'],
	['Pending Approval', 'INTERACTION', 'Under process'],
	['Pending Change', 'INCIDENT', 'Under process'],
	['Pending Change', 'INTERACTION', 'Under process'],
	['Pending Customer', 'INCIDENT', 'Info required from customer'],
	['Pending Customer', 'INTERACTION', 'Info required from customer'],
	['Pending Evidence', 'INCIDENT', 'Under process'],
	['Pending Other', 'INCIDENT', 'Under process'],
	['Pending Other', 'INTERACTION', 'Under process'],
	['Pending Other Department', 'INTERACTION', 'Under process'],
	['Pending Parent Incident', 'INCIDENT', 'Under process'],
	['Pending Requestor', 'INTERACTION', 'Under process'],
	['Pending TRA', 'INTERACTION', 'Under process'],
	['Pending Vendor', 'INCIDENT', 'Under process'],
	['Pending Vendor', 'INTERACTION', 'Under process'],
	['Pending WorkOrder', 'INCIDENT', 'Under process'],
	['Referred', 'INTERACTION', 'Under process'],
	['Referred', 'INCIDENT', 'Under process'],
	['Rejected', 'INTERACTION', 'Closed'],
	['Rejected', 'INCIDENT', 'Closed'],
	['Replaced Problem', 'INTERACTION', 'Under process'],
	['Replaced Problem', 'INCIDENT', 'Under process'],
	['Resolved', 'INTERACTION', 'Completed'],
	['Resolved', 'INCIDENT', 'Completed'],
	['Suspended', 'INTERACTION', 'Closed'],
	['Suspended', 'INCIDENT', 'Closed'],
	['Withdrawal Requested', 'INTERACTION', 'Under process'],
	['Withdrawn', 'INTERACTION', 'Withdrawn'],
	['Work In Progress', 'INTERACTION', 'Under process'],
	['Work In Progress', 'INCIDENT', 'Under process'],
];

export const resolveTicketStatus = (ticket: Ticket, typeOfTicket: types.troubleTicketing.typeOfTicket) => {
	return statuses.find(([status, _typeOfTicket]) => {
		return status === ticket.status && typeOfTicket === _typeOfTicket;
	});
};
